/***********
 Desktop Nav
 ************/

// drop menu buttons
const headerButtons = document.querySelectorAll('.headerNavDropButton');

// open dropdowns and set attributes
headerButtons.forEach(button => {
    button.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            this.setAttribute('aria-expanded', 'false');
        } else {
            closeDesktopMenu();
            this.classList.add('active');
            this.setAttribute('aria-expanded', 'true');
        }
    })
})

// closing menu when mouse leaves the menu area
document.querySelectorAll('.headerNavDrop').forEach(drop => {
    drop.addEventListener('mouseleave', closeDesktopMenu)
})

// closing the menu when focus leaves the menu area - keyboard
document.querySelectorAll('.headerNavDrop').forEach(drop => {
    drop.addEventListener('focusout', function (e) {
        // if menu does not contain the related target, new focus, close menu
        if (!e.currentTarget.contains(e.relatedTarget)) {
            closeDesktopMenu();
        }
    })
})

// closing menu on escape and focus on main content
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        closeDesktopMenu();
        document.querySelector('.mainContentFocus')?.focus();
    }
});

function closeDesktopMenu() {
    headerButtons.forEach(el => {
        el.classList.remove('active');
        el.setAttribute('aria-expanded', 'false');
    })
}

/**************
 Mobile Nav
 ***************/

const slider = document.querySelector("#slider");

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", function () {
        // quick menu chems open dropdown
        if (this.dataset.name === 'chems') {
            document.querySelector("#sliderNavGroupButton").click();
        }
        slider.showModal();
        slider.classList.add("active");
        document.querySelector("body").classList.add("noScroll");
    });
});

// closing events
slider.addEventListener('close', () => {
    slider.classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
})

slider.addEventListener("click", function (e) {
    if (e.target === this) {
        closeNav();
    }
});

document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", () => {
        closeNav();
    });
});

function closeNav() {
    slider.classList.remove("active");
    // close extra menu
    document.querySelector("#sliderNavGroupButton").classList.remove('active');
    document.querySelector("#sliderNavGroupButton").setAttribute('aria-expanded', 'false');
    setTimeout(() => {
        document.querySelector("body").classList.remove("noScroll");
        slider.close();
    }, 300)
}

// drop down menus on mobile
document.querySelector("#sliderNavGroupButton").addEventListener("click", function () {
    if (this.classList.contains('active')) {
        this.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
    } else {
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
    }
});